// extracted by mini-css-extract-plugin
export default {"header":"yeQdVS","headerTitle":"AFFbw7","headerTitleUx4":"_wtKNJ","headerSubtitle":"AsMJm2","headerSubtitleUx4":"oN6axQ","headerSubtitleGray":"EOAVDO","headerSubtitleOffer":"dKDITl"};